import React from 'react'
import styled from 'styled-components';
import deletePromptBg from "../../assets/images/deletePRomptBG.png";
import { useTheme } from '../../middleware/ThemeContext';
import CrossIcon from '../../assets/icons/CrossIcon';
import LoadingCircleIcon from '../../assets/icons/LoadingCircleIcon';
import DeleteIcon from '../../assets/icons/DeleteIcon';
import MergeIcon from '../../assets/icons/MergeIcon';

interface MergeProps {
    title?: string;
    subTitle?: string;
    onCancel: () => void;
    onConfirm: (Record: any) => void;
    loading?: boolean;
}

const MergeConfirmPopup: React.FC<MergeProps> = ({ title, subTitle, onCancel, onConfirm, loading }) => {
    const {theme} = useTheme();
  return (
    <Overlay>
      <Container theme={theme}>
        <Header>
          {/* <BigIconWrapper>
            <DeletePromptIcon />
          </BigIconWrapper> */}
        </Header>
        <Body>
          <Title theme={theme}>
            {title ?? "Merge record?"}
          </Title>
          <Subtitle theme={theme}>
            {subTitle ??
              `Are you sure you want to merge this record? Merging records 
              is an irreversible process. Once merged cannot be undo.`}
          </Subtitle>
        </Body>

        <Actions>
          <ActionButton theme={theme} variant="delete" onClick={onCancel}>
            <CrossIcon />
            <label> Cancel</label>
          </ActionButton>
          <ActionButton theme={theme} variant="cancel" onClick={onConfirm}>
            {loading ? (
              <>
                <label>Merging...</label>
                <LoadingCircleIcon color={theme.CorporateTheme.colors.background} />
              </>
            ) : (
              <>
                <MergeIcon color={theme.CorporateTheme.colors.background} />
                <label> Merge Record</label>
              </>
            )}
          </ActionButton>
        </Actions>
      </Container>
    </Overlay>
  )
}

export default MergeConfirmPopup


const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Container = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: '600px',
  background: theme.CorporateTheme.colors.background,
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.15)',
  textAlign: 'center',
  fontFamily: '"Segoe UI", sans-serif',
}));

const Header = styled.div`
  background-image: url(${deletePromptBg});
  background-repeat: repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 90px;
`;

const BigIconWrapper = styled.div`
  background-color: #fde6e6;
  padding: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Body = styled.div`
  padding: 24px;
  padding-top: 0px;
`;

const Title = styled('h2')(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 700,
  fontFamily: '"Raleway", sans-serif',
  color: theme.CreateFormTheme.colors.primary,
  marginBottom: '12px',
}));

const Subtitle = styled('p')(({ theme }) => ({
  fontSize: '14px',
  color: theme.CorporateTheme.colors.textSecondary,
  fontWeight: 400,
  lineHeight: 1.5,
  fontFamily: '"Raleway", sans-serif',
}));

const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 24px 24px 50px;
`;

const ActionButton = styled.button<{
  variant: "delete" | "cancel" | "submit";
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 16px;
  padding: 7px 16px;
  border: 2px solid ${({theme}) => theme.CreateFormTheme.colors.border};
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
  background-color: ${({ variant, theme }) =>
    variant === "delete" || variant === "submit"
      ? theme.CorporateTheme.colors.background
      : theme.CreateFormTheme.colors.primaryBtn};
  color: ${({ variant, theme }) =>
    variant === "delete" || variant === "submit" ? theme.CorporateTheme.colors.textSecondary : theme.CorporateTheme.colors.background};

  label {
    margin-top: 2px;
    font-family: "Raleway", sans-serif;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    display: block;
  }

  &:hover {
    opacity: 0.9;
    background: ${({ variant, theme }) =>
    variant === "delete" || variant === "submit"
      ? theme.CreateFormTheme.colors.hoverCancel
      : theme.CreateFormTheme.colors.hoverPrimary};
  }
`;

// const DeleteIconStyled = styled(DeleteIcon)`
//   width: 16px;
//   height: 16px;
// `;

// const CloseIconStyled = styled(CloseWhiteIcon)`
//   width: 16px;
//   height: 16px;
// `;